import { render, staticRenderFns } from "./DistributorForSales.vue?vue&type=template&id=68e77c8a"
import script from "./DistributorForSales.vue?vue&type=script&lang=js"
export * from "./DistributorForSales.vue?vue&type=script&lang=js"
import style0 from "./DistributorForSales.vue?vue&type=style&index=0&id=68e77c8a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports